import React from "react"

import YearTabComponent from "./year-tab-component"

class YearTabContainer extends React.Component {

	render() {
		return (
			<YearTabComponent year={this.props.year} onSelected={this._handleSelected.bind(this)} current={this.props.current} />
		)
	}

	_handleSelected() {
		this.props.onSelected(this.props.year)
	}

}

export default YearTabContainer



// WEBPACK FOOTER //
// ./src/component/scenarii/manager/year-tab-container.js